import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  redirectPath,
  ...rest
}) => {
  const routeComponent = props =>
    isAuthenticated ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: rest.pathname || '/login',
          state: { from: props.location },
        }}
      />
    );
  return <Route {...rest} render={routeComponent} />;
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/PrivateRoute.js